module.exports = __webpack_public_path__ + "img/logo-sm.308239bf.png";